module.exports = __webpack_public_path__ + "static/media/mrs-teller-avatar.e458e4c5.png";